import React from 'react';
import AbstractRequestTask from '../../AbstractRequestTask';

class StatusControlPinTask extends AbstractRequestTask {

    constructor(config, params) {
        super();
        this.config = config;
        this.params = params;
    }

    getUrl() {
        const domain = this.config.url_dominio_microfwk;

        return `${domain}services/user/statuscontrolpin`
    }

    getParams() {
        let params = super.getParams(this.config);
        this.params = Object.assign(params, this.params);

        return params;
    }

    success(data, b) {
        let isValid = super.success(data, b);
        if (!isValid) {
            let newData = super.parseErrors(data);
            return this.reject(newData, b);
        }
        this.resolve(data);
    }

}

export default StatusControlPinTask;
